/**
 * Copyright 2024 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */

import Breadcrumbs from '@/components/AZCustomComponent/BreadcrumbSTARC';
import { View } from '@az/starc-ui';
import styles from '../components/BlogsBreadcrumb.module.scss';
import { useBlogBreadcrumbData } from '../hooks/useBlogBreadcrumbData';

type BlogBreadcrumbProp = {
  primaryCategory?: string;
  lastItemDisabled?: boolean;
};

const BlogBreadcrumb = ({ primaryCategory, lastItemDisabled }: BlogBreadcrumbProp) => {
  const breadcrumbData = useBlogBreadcrumbData({ primaryCategory });

  return (
    <View data-testid="breadCrumb">
      <Breadcrumbs
        data={breadcrumbData}
        customClass={styles.breadcrumbContainer}
        lastItemDisabled={lastItemDisabled}
      />
    </View>
  );
};

export default BlogBreadcrumb;
